import { useEffect, useState } from "react";
import { trackEvent } from "@/lib/audit";

export type DemoTrigger =
  | "goal"
  | "prediction"
  | "survey"
  | "celebration"
  | "restart"
  | "pause"
  | "resume"
  | "start";

const EVT = "ss2026:demo-trigger";

export function dispatchDemo(trigger: DemoTrigger, payload?: Record<string, unknown>) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(EVT, { detail: { trigger, payload } }));
  void trackEvent("demo_trigger", { trigger, ...(payload ?? {}) });
}

export function useDemoTrigger(handler: (t: DemoTrigger, p?: Record<string, unknown>) => void) {
  useEffect(() => {
    const fn = (e: Event) => {
      const ce = e as CustomEvent<{ trigger: DemoTrigger; payload?: Record<string, unknown> }>;
      handler(ce.detail.trigger, ce.detail.payload);
    };
    window.addEventListener(EVT, fn);
    return () => window.removeEventListener(EVT, fn);
  }, [handler]);
}

export function useDemoPanelVisible(): boolean {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("demo") === "panel") setVisible(true);
    const onKey = (e: KeyboardEvent) => {
      // Ctrl+Shift+D opens panel
      if (e.ctrlKey && e.shiftKey && (e.key === "D" || e.key === "d")) {
        e.preventDefault();
        setVisible((v) => !v);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);
  return visible;
}
